import React from 'react'
import { LineDistributionConfigType, LineDistributionItemType } from 'src/lib/types/analytics'
import { Tooltip } from '@mui/material'
const colors = ['#91C1E3', '#EFD080', '#BBE599', '#E49B9B', '#8A89DF']

const LineDistribution: React.FC<LineDistributionConfigType> = ({ distributionItems }) => {
  let totalShare = 0
  distributionItems?.forEach((distributionItem: LineDistributionItemType) => (totalShare += distributionItem.share))
  return (
    <div className='w-full flex flex-col gap-3'>
      <div className='w-full h-9 flex flex-row rounded-lg overflow-hidden'>
        {distributionItems?.map((distributionItem: LineDistributionItemType, index: number) => {
          const itemShare = parseFloat(Number((distributionItem.share / totalShare) * 100).toString()).toFixed(2)
          return (
            <Tooltip
              key={`item-${index + 1}`}
              title={
                <div className='flex flex-col gap-0.5'>
                  <p className='text-xs font-medium'>
                    Product: <span className='font-normal'>{distributionItem?.title}</span>
                  </p>
                  <p className='text-xs font-medium'>
                    Share: <span className='font-normal'>{itemShare + '%'}</span>
                  </p>
                </div>
              }
            >
              <div
                style={{
                  width: `${itemShare}%`,
                  background: colors[(index + 1) % 5],
                  backgroundColor: colors[(index + 1) % 5]
                }}
              />
            </Tooltip>
          )
        })}
      </div>
      <div className='w-full h-9 justify-between flex flex-row overflow-hidden px-2'>
        {distributionItems?.map((distributionItem: LineDistributionItemType, index: number) => {
          return (
            <div key={`item-${index + 1}`} className='flex flex-row gap-1'>
              <div
                style={{
                  width: `6px`,
                  background: colors[(index + 1) % 5],
                  backgroundColor: colors[(index + 1) % 5]
                }}
              />
              {distributionItem?.label}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default LineDistribution
